import axios from "axios";
import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import "./styles/Expenses.css";

const API = "https://salathai.co.tz/mrms/Expenses.php";
const PURCHASE_API = "https://salathai.co.tz/mrms/Purchase.php";
const PRODUCTS_API = "https://salathai.co.tz/mrms/Products.php";
const VENDOR_API = "https://salathai.co.tz/mrms/Vendor.php";
const ITEMS_PER_PAGE = 10;

const CATEGORIES = [
    "CONSULTING", "DECORATION", "SMALLWARE","DELIVERY FEE", "STAFF MEDICAL CHECKUP", "STAFF LOAN", "IT AND INTERNET", "OFFICE: STATIONARY", "PACKAGING MATERIALS", "RAW", "TRANSPORT",
    "CLEANING-ITEMS", "CLEANING-SERVICE", "STAFF RECURATIONS", "SALES & MARKETING",
    "BURGER PAYMENT", "SERVICE & REPAIR", "KITCHENWARE", "ELECTRICITY", "GROCERIES",
    "SALARY", "ADVANCE PAYMENT", "SALES COMMISSION", "BOTTLES", "LABOUR COST",
    "DIRECTORS", "NETWORK COMMISSION", "HARDWARE", "SOFT DRINKS", "BEERS", "LIQUORS", 
    "FRUITS & VEGETABLES", "MEAT & CHICKEN", "MILK", "SAUCE", "SPICES", "DRINKS", "MISCELLANEOUS"
];

const PAYMENT_METHODS = ["CASH", "CRDB_BANK", "SELECOM", "M-PESA", "MIXX_BY_YAS"];
const RECEIPT_OPTIONS = ["YES", "NO"];

const REPORT_TYPES = [
    { value: "last_60_minutes", label: "Last 60 Minutes" },
    { value: "last_24_hours", label: "Last 24 Hours" },
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last_7_days", label: "Last 7 Days" },
    { value: "this_week", label: "This Week" },
    { value: "last_week", label: "Last Week" },
    { value: "last_30_days", label: "Last 30 Days" },
    { value: "this_month", label: "This Month" },
    { value: "last_month", label: "Last Month" },
    { value: "day_to_day", label: "Custom Range" }
];

const PURCHASEABLE_CATEGORIES = [
    'RAW', 'PACKAGING MATERIALS', 'KITCHENWARE', 'BOTTLES', 'CLEANING-ITEMS', 
    'GROCERIES', 'FRUITS & VEGETABLES', 'MEAT & CHICKEN', 
    'MILK', 'SAUCE', 'SPICES', 'SOFT DRINKS', 'BEERS', 'LIQUORS'
];

const roundPurchaseAmount = (amount) => {
    return Math.round(amount / 10) * 10;
};

export default function Expenses() {
    const token = localStorage.getItem("token");
    const staff = JSON.parse(localStorage.getItem("staff") || "{}");
    const [expenses, setExpenses] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [showFormModal, setShowFormModal] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [reportType, setReportType] = useState("today");
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [isExporting, setIsExporting] = useState(false);
    const [form, setForm] = useState({
        category: "", payment_method: "CASH", amount: "", description: "", receipt: "NO"
    });
    const [selectedExpense, setSelectedExpense] = useState(null);
    
    const [items, setItems] = useState([]);
    const [remainingAmount, setRemainingAmount] = useState(0);
    const [showItemModal, setShowItemModal] = useState(false);
    const [currentItem, setCurrentItem] = useState({
        product_name: '',
        category: '',
        quantity: '',
        total_price: '',
        unit: '',
        price_per_unit: ''
    });
    
    const [products, setProducts] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [filteredVendors, setFilteredVendors] = useState([]);
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [showVendorDropdown, setShowVendorDropdown] = useState(false);
    const [productSearch, setProductSearch] = useState("");
    const [vendorSearch, setVendorSearch] = useState("");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [savingPurchase, setSavingPurchase] = useState(false);
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [loadingVendors, setLoadingVendors] = useState(false);
    
    const productInputRef = useRef(null);
    const productDropdownRef = useRef(null);
    const vendorInputRef = useRef(null);
    const vendorDropdownRef = useRef(null);

    const getToken = () => localStorage.getItem("token") || "";

    useEffect(() => {
        if (!token) {
            Swal.fire("Session expired", "Please login again", "warning");
            return;
        }
        loadExpenses();
        fetchProducts();
        fetchVendors();
    }, [token]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (productDropdownRef.current && !productDropdownRef.current.contains(event.target) &&
                productInputRef.current && !productInputRef.current.contains(event.target)) {
                setShowProductDropdown(false);
            }
            if (vendorDropdownRef.current && !vendorDropdownRef.current.contains(event.target) &&
                vendorInputRef.current && !vendorInputRef.current.contains(event.target)) {
                setShowVendorDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const loadExpenses = async () => {
        try {
            const res = await fetch(`${API}?token=${token}`);
            const data = await res.json();
            if (Array.isArray(data)) setExpenses(data);
        } catch {
            Swal.fire("Error", "Server not reachable", "error");
        }
    };

    const fetchProducts = async () => {
        setLoadingProducts(true);
        try {
            const response = await axios.get(`${PRODUCTS_API}?token=${getToken()}&products=1`);
            
            let productsData = [];
            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                productsData = response.data.data;
            } else if (Array.isArray(response.data)) {
                productsData = response.data;
            } else {
                productsData = [];
            }
            
            setProducts(productsData);
            setFilteredProducts(productsData);
        } catch (error) {
            console.error("Error fetching products:", error);
            setProducts([]);
            setFilteredProducts([]);
        } finally {
            setLoadingProducts(false);
        }
    };

    const fetchVendors = async () => {
        setLoadingVendors(true);
        try {
            const response = await axios.get(`${VENDOR_API}?token=${getToken()}&vendors=1`);
            
            let vendorsData = [];
            if (Array.isArray(response.data)) {
                vendorsData = response.data;
            } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
                vendorsData = response.data.data;
            } else {
                vendorsData = [];
            }
            
            setVendors(vendorsData);
            setFilteredVendors(vendorsData);
        } catch (error) {
            console.error("Error fetching vendors:", error);
            setVendors([]);
            setFilteredVendors([]);
        } finally {
            setLoadingVendors(false);
        }
    };

    const isPurchaseableCategory = (category) => {
        return PURCHASEABLE_CATEGORIES.includes(category);
    };

    const safeNumber = (value) => {
        if (value === null || value === undefined || value === "") return 0;
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    };

    const formatAmount = (amount) => {
        if (!amount && amount !== 0) return "0";
        return Math.round(amount).toLocaleString();
    };

    const handleCategorySearch = (input) => {
        if (input.length > 0) {
            const matches = CATEGORIES.filter(cat => 
                cat.toLowerCase().includes(input.toLowerCase())
            );
            setFilteredCategories(matches);
            setShowCategoryDropdown(matches.length > 0);
        } else {
            setShowCategoryDropdown(false);
        }
    };

    const selectCategory = (category) => {
        setForm(prev => ({ ...prev, category }));
        setShowCategoryDropdown(false);
        if (!isPurchaseableCategory(category)) {
            setItems([]);
            setRemainingAmount(0);
        }
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
        if (name === "category") {
            handleCategorySearch(value);
            if (!isPurchaseableCategory(value)) {
                setItems([]);
                setRemainingAmount(0);
            }
        }
    };

    const handleAmountChange = (e) => {
        const newAmount = safeNumber(e.target.value);
        setForm(prev => ({ ...prev, amount: e.target.value }));
        const itemsTotal = items.reduce((sum, item) => sum + (safeNumber(item.total_price)), 0);
        setRemainingAmount(newAmount - itemsTotal);
    };

    const handleProductSearch = (e) => {
        const value = e.target.value;
        setProductSearch(value);
        setSelectedProduct(null);
        
        if (value.length > 0) {
            const filtered = products.filter(p => 
                p.item_name && p.item_name.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredProducts(filtered.slice(0, 15));
            setShowProductDropdown(true);
        } else {
            setFilteredProducts([]);
            setShowProductDropdown(false);
        }
    };

    const handleVendorSearch = (e) => {
        const value = e.target.value;
        setVendorSearch(value);
        setSelectedVendor(null);
        
        if (value.length > 0) {
            const filtered = vendors.filter(v => 
                v.name && v.name.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredVendors(filtered.slice(0, 15));
            setShowVendorDropdown(true);
        } else {
            setFilteredVendors([]);
            setShowVendorDropdown(false);
        }
    };

    const selectProduct = (product) => {
        setSelectedProduct(product);
        setProductSearch(product.item_name);
        setShowProductDropdown(false);
        setCurrentItem(prev => ({
            ...prev,
            product_name: product.item_name,
            category: product.category,
            unit: product.base_unit || "PCS"
        }));
        
        if (product.vendor_name && product.vendor_id) {
            const productVendor = vendors.find(v => v.id == product.vendor_id);
            if (productVendor) {
                setSelectedVendor(productVendor);
                setVendorSearch(productVendor.name);
            } else {
                setSelectedVendor({ 
                    id: product.vendor_id, 
                    name: product.vendor_name 
                });
                setVendorSearch(product.vendor_name);
            }
        }
    };

    const selectVendor = (vendor) => {
        setSelectedVendor(vendor);
        setVendorSearch(vendor.name);
        setShowVendorDropdown(false);
    };

    const calculatePricePerUnit = (quantity, totalPrice) => {
        if (!quantity || quantity <= 0 || !totalPrice || totalPrice <= 0) return 0;
        return totalPrice / quantity;
    };

    const addItem = () => {
        const qty = safeNumber(currentItem.quantity);
        const totalPriceRaw = safeNumber(currentItem.total_price);
        
        if (qty <= 0) {
            Swal.fire("Error", "Valid quantity is required", "warning");
            return;
        }
        
        if (totalPriceRaw <= 0) {
            Swal.fire("Error", "Valid total price is required", "warning");
            return;
        }
        
        if (!currentItem.product_name) {
            Swal.fire("Error", "Product name is required", "warning");
            return;
        }
        
        if (!selectedVendor) {
            Swal.fire("Error", "Please select a vendor for this item", "warning");
            return;
        }
        
        const calculatedPricePerUnit = calculatePricePerUnit(qty, totalPriceRaw);
        const roundedTotalPrice = roundPurchaseAmount(totalPriceRaw);
        const finalPricePerUnit = roundedTotalPrice / qty;
        const unit = selectedProduct?.base_unit || currentItem.unit || "PCS";
        
        const newItem = {
            product_name: currentItem.product_name,
            category: currentItem.category || form.category,
            quantity: qty,
            unit: unit,
            total_price: roundedTotalPrice,
            price_per_unit: finalPricePerUnit,
            original_total_price: totalPriceRaw,
            vendor_id: selectedVendor.id,
            vendor_name: selectedVendor.name
        };
        
        const newItems = [...items, newItem];
        const newTotal = newItems.reduce((sum, item) => sum + item.total_price, 0);
        const expenseAmount = safeNumber(form.amount);
        
        if (newTotal > expenseAmount) {
            Swal.fire("Error", `Total items amount (${formatAmount(newTotal)}) exceeds expense amount (${formatAmount(expenseAmount)}).`, "warning");
            return;
        }
        
        setItems(newItems);
        setRemainingAmount(expenseAmount - newTotal);
        setShowItemModal(false);
        setCurrentItem({ product_name: '', category: '', quantity: '', total_price: '', unit: '', price_per_unit: '' });
        setProductSearch("");
        setSelectedProduct(null);
        
        let roundingMessage = "";
        if (Math.abs(roundedTotalPrice - totalPriceRaw) > 0.01) {
            roundingMessage = ` (rounded from ${formatAmount(totalPriceRaw)} to ${formatAmount(roundedTotalPrice)} TZS)`;
        }
        
        Swal.fire({
            title: "Item Added",
            html: `${newItem.product_name}<br>Quantity: ${qty} ${unit}<br>Price/Unit: ${formatAmount(finalPricePerUnit)} TZS<br>Total: ${formatAmount(roundedTotalPrice)} TZS${roundingMessage}<br><strong>Remaining budget: ${formatAmount(expenseAmount - newTotal)} TZS</strong>`,
            icon: "success",
            timer: 3000,
            showConfirmButton: true
        });
    };

    const removeItem = (index) => {
        const newItems = items.filter((_, i) => i !== index);
        setItems(newItems);
        const expenseAmount = safeNumber(form.amount);
        const newTotal = newItems.reduce((sum, item) => sum + item.total_price, 0);
        setRemainingAmount(expenseAmount - newTotal);
    };

    const exportExpenses = async () => {
        setIsExporting(true);
        try {
            let url = `${API}?export_expenses=1&token=${token}&report=${reportType}`;
            if (reportType === "day_to_day") {
                url += `&start=${startDate}&end=${endDate}`;
            }
            
            const response = await fetch(url);
            if (!response.ok) throw new Error("Export failed");
            
            const blob = await response.blob();
            const url_blob = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url_blob;
            a.download = "expenses_report.xls";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url_blob);
            
            Swal.fire("Success", "Excel report downloaded successfully.", "success");
            setShowReportModal(false);
        } catch (error) {
            Swal.fire("Export Failed", error.message, "error");
        } finally {
            setIsExporting(false);
        }
    };

    const saveExpense = async () => {
        if (!form.category) return Swal.fire("Error", "Category is required", "warning");
        if (!form.amount || safeNumber(form.amount) <= 0) return Swal.fire("Error", "Valid amount is required", "warning");

        const expenseAmount = safeNumber(form.amount);
        
        if (isPurchaseableCategory(form.category)) {
            if (items.length === 0) {
                return Swal.fire("Error", "Please add at least one item for this purchase", "warning");
            }
            
            const itemsTotal = items.reduce((sum, item) => sum + item.total_price, 0);
            
            if (Math.abs(itemsTotal - expenseAmount) > 1) {
                return Swal.fire("Error", `Total items amount (${formatAmount(itemsTotal)}) must equal expense amount (${formatAmount(expenseAmount)}). Please adjust your items or expense amount.`, "warning");
            }
        }

        setSavingPurchase(true);
        try {
            let savedPurchaseIds = [];
            
            if (isPurchaseableCategory(form.category) && items.length > 0) {
                for (const item of items) {
                    const productInfo = products.find(p => p.item_name === item.product_name);
                    
                    const packagingType = productInfo?.purchase_packaging || (productInfo?.category === 'GROCERIES' ? 'BAG' : 'BOTTLE');
                    const packagingQuantity = parseFloat(productInfo?.packaging_quantity) || 1;
                    
                    let quantityInPacks = item.quantity;
                    if (packagingType && packagingType !== "UNIT" && packagingType !== "") {
                        quantityInPacks = item.quantity / packagingQuantity;
                    }
                    
                    const pricePerPack = item.price_per_unit * packagingQuantity;
                    
                    const purchaseData = {
                        category: form.category,
                        product_id: productInfo?.id || null,
                        product_name: item.product_name,
                        vendor_id: item.vendor_id,
                        vendor_name: item.vendor_name,
                        quantity: parseFloat(quantityInPacks.toFixed(2)),
                        packaging_type: packagingType,
                        packaging_quantity: parseFloat(packagingQuantity),
                        price_per_pack: parseFloat(pricePerPack.toFixed(2)),
                        total_amount: item.total_price
                    };
                    
                    try {
                        const purchaseResponse = await axios.post(`${PURCHASE_API}?token=${getToken()}`, purchaseData);
                        if (purchaseResponse.data && purchaseResponse.data.id) {
                            savedPurchaseIds.push(purchaseResponse.data.id);
                        }
                    } catch (purchaseError) {
                        console.error("Purchase save error:", purchaseError);
                    }
                }
            }
            
            const payload = {
                category: form.category,
                payment_method: form.payment_method,
                amount: expenseAmount,
                description: form.description || null,
                receipt: form.receipt
            };
            
            if (isPurchaseableCategory(form.category)) {
                payload.items = items.map(item => ({
                    product_name: item.product_name,
                    category: item.category || form.category,
                    quantity: item.quantity,
                    unit: item.unit,
                    price_per_unit: item.price_per_unit,
                    total_price: item.total_price,
                    vendor_name: item.vendor_name,
                    vendor_id: item.vendor_id
                }));
                if (savedPurchaseIds.length > 0) {
                    payload.purchase_ids = savedPurchaseIds;
                }
            }

            const url = isEditing ? `${API}?id=${selectedExpense.id}` : API;
            const method = isEditing ? "PUT" : "POST";

            const res = await fetch(url, {
                method,
                headers: { 
                    "Content-Type": "application/json", 
                    "Authorization": `Bearer ${token}` 
                },
                body: JSON.stringify(payload)
            });

            const data = await res.json();
            if (data.error) return Swal.fire("Error", data.error, "error");
            
            Swal.fire("Success", isPurchaseableCategory(form.category) 
                ? `${items.length} purchase record(s) saved successfully!` 
                : "Expense saved successfully!", "success");
            setShowFormModal(false);
            resetForm();
            loadExpenses();
        } catch (error) {
            console.error("Save error:", error);
            Swal.fire("Error", "Failed to save expense: " + (error.message || "Unknown error"), "error");
        } finally {
            setSavingPurchase(false);
        }
    };

    const deleteExpense = async (expense) => {
        const confirm = await Swal.fire({
            title: "Delete Expense?",
            text: `${expense.category} - TZS ${formatAmount(expense.amount)}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33"
        });
        if (!confirm.isConfirmed) return;

        try {
            await fetch(`${API}?id=${expense.id}`, {
                method: "DELETE",
                headers: { "Authorization": `Bearer ${token}` }
            });
            setExpenses(prev => prev.filter(e => e.id !== expense.id));
            Swal.fire("Deleted", "Expense removed", "success");
        } catch {
            Swal.fire("Error", "Delete failed", "error");
        }
    };

    const resetForm = () => {
        setForm({ category: "", payment_method: "CASH", amount: "", description: "", receipt: "NO" });
        setItems([]);
        setRemainingAmount(0);
        setIsEditing(false);
        setSelectedExpense(null);
        setShowCategoryDropdown(false);
        setProductSearch("");
        setVendorSearch("");
        setSelectedProduct(null);
        setSelectedVendor(null);
    };

    const openAddForm = () => { resetForm(); setShowFormModal(true); };

    const openEditForm = (expense) => {
        setForm({
            category: expense.category,
            payment_method: expense.payment_method,
            amount: expense.amount,
            description: expense.description || "",
            receipt: expense.receipt || "NO"
        });
        setSelectedExpense(expense);
        setIsEditing(true);
        setItems([]);
        setRemainingAmount(0);
        setShowFormModal(true);
    };

    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    const paginated = expenses.slice(start, start + ITEMS_PER_PAGE);
    const totalPages = Math.ceil(expenses.length / ITEMS_PER_PAGE);

    return (
        <div className="expenses-container">
            <div className="expenses-header">
                <div>
                    <h1 className="expenses-title">Expenses Management</h1>
                    <p className="expenses-subtitle">Track and manage all business expenditures</p>
                </div>
                <div className="expenses-header-buttons">
                    <button onClick={() => setShowReportModal(true)} className="btn btn-secondary">Excel Report</button>
                    <button onClick={openAddForm} className="btn btn-primary">Add Expense</button>
                </div>
            </div>

            <div className="expenses-stats">
                <div className="stat-card">
                    <div className="stat-label">Total Expenses</div>
                    <div className="stat-value">{expenses.length}</div>
                </div>
                <div className="stat-card">
                    <div className="stat-label">Total Amount</div>
                    <div className="stat-value">TZS {expenses.reduce((s, e) => s + (e.amount || 0), 0).toLocaleString()}</div>
                </div>
                <div className="stat-card">
                    <div className="stat-label">Average Expense</div>
                    <div className="stat-value">TZS {expenses.length > 0 ? (expenses.reduce((s, e) => s + (e.amount || 0), 0) / expenses.length).toLocaleString() : 0}</div>
                </div>
            </div>

            <div className="expenses-table-wrapper">
                <table className="expenses-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Category</th>
                            <th>Payment Method</th>
                            <th>Amount (TZS)</th>
                            <th>Receipt</th>
                            <th>Items</th>
                            <th>Recorded By</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginated.map((expense) => (
                            <tr key={expense.id}>
                                <td>{new Date(expense.created_at).toLocaleDateString('en-GB')}</td>
                                <td><span className="badge badge-category">{expense.category}</span></td>
                                <td><span className="badge badge-payment">{expense.payment_method}</span></td>
                                <td className="amount-cell">TZS {formatAmount(expense.amount)}</td>
                                <td><span className={`receipt-badge ${expense.receipt === 'YES' ? 'receipt-yes' : 'receipt-no'}`}>{expense.receipt}</span></td>
                                <td>{expense.items_count > 0 ? <span className="items-badge">{expense.items_count} items</span> : "-"}</td>
                                <td><span className="staff-name">{expense.staff_name || staff.full_name || 'System'}</span></td>
                                <td className="actions-cell">
                                    <button onClick={() => openEditForm(expense)} className="action-btn edit-btn">Edit</button>
                                    <button onClick={() => deleteExpense(expense)} className="action-btn delete-btn">Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {totalPages > 1 && (
                <div className="pagination">
                    <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">Previous</button>
                    <span className="page-info">Page {currentPage} of {totalPages}</span>
                    <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">Next</button>
                </div>
            )}

            {/* Add/Edit Expense Modal */}
            {showFormModal && (
                <div className="modal-overlay" onClick={() => setShowFormModal(false)}>
                    <div className="modal-content modal-lg" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>{isEditing ? "Edit Expense" : "Add New Expense"}</h2>
                            <button onClick={() => setShowFormModal(false)} className="modal-close">×</button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Category <span className="required">*</span></label>
                                <div className="search-wrapper">
                                    <input
                                        type="text"
                                        name="category"
                                        value={form.category}
                                        onChange={handleChange}
                                        placeholder="Search or select category..."
                                        autoComplete="off"
                                    />
                                    {showCategoryDropdown && (
                                        <div className="dropdown">
                                            {filteredCategories.map(cat => (
                                                <div key={cat} onClick={() => selectCategory(cat)} className="dropdown-item">
                                                    {cat}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Payment Method</label>
                                    <select name="payment_method" value={form.payment_method} onChange={handleChange}>
                                        {PAYMENT_METHODS.map(method => (
                                            <option key={method} value={method}>{method}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Amount <span className="required">*</span></label>
                                    <input
                                        type="number"
                                        name="amount"
                                        value={form.amount}
                                        onChange={handleAmountChange}
                                        placeholder="0"
                                        step="1"
                                    />
                                    <small className="hint-text">
                                        Total expense amount (sum of all purchase items)
                                    </small>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Receipt</label>
                                    <select name="receipt" value={form.receipt} onChange={handleChange}>
                                        {RECEIPT_OPTIONS.map(opt => (
                                            <option key={opt} value={opt}>{opt}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Description</label>
                                    <input
                                        type="text"
                                        name="description"
                                        value={form.description}
                                        onChange={handleChange}
                                        placeholder="Optional description..."
                                    />
                                </div>
                            </div>

                            {isPurchaseableCategory(form.category) && (
                                <div className="items-section">
                                    <div className="items-header">
                                        <label>Purchase Items (Amounts rounded to nearest 10 TZS)</label>
                                        <button 
                                            type="button"
                                            onClick={() => setShowItemModal(true)}
                                            className="add-item-btn"
                                            disabled={!form.amount || safeNumber(form.amount) <= 0}
                                        >
                                            Add Item
                                        </button>
                                    </div>
                                    
                                    {items.length > 0 && (
                                        <div className="items-table-container">
                                            <table className="items-table">
                                                <thead>
                                                    <tr>
                                                        <th>Product</th>
                                                        <th>Vendor</th>
                                                        <th>Qty</th>
                                                        <th>Unit</th>
                                                        <th>Price/Unit</th>
                                                        <th>Total (Rounded)</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td><strong>{item.product_name}</strong></td>
                                                            <td><span className="vendor-badge">{item.vendor_name}</span></td>
                                                            <td>{item.quantity}</td>
                                                            <td>{item.unit}</td>
                                                            <td>TZS {formatAmount(item.price_per_unit)}</td>
                                                            <td className="item-amount">TZS {formatAmount(item.total_price)}</td>
                                                            <td>
                                                                <button onClick={() => removeItem(idx)} className="remove-item-btn">×</button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan="5" className="total-label">Total Items:</td>
                                                        <td className="total-amount">TZS {formatAmount(items.reduce((s, i) => s + i.total_price, 0))}</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="5" className="remaining-label">Remaining:</td>
                                                        <td className={`remaining-amount ${remainingAmount < 0 ? 'negative' : remainingAmount === 0 ? 'zero' : ''}`}>
                                                            TZS {formatAmount(remainingAmount)}
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    )}
                                    
                                    {items.length === 0 && (
                                        <div className="no-items">
                                            No items added. Click "Add Item" to record purchases.
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => setShowFormModal(false)} className="btn btn-secondary">Cancel</button>
                            <button onClick={saveExpense} disabled={savingPurchase} className="btn btn-primary">
                                {savingPurchase ? "Saving..." : (isEditing ? "Update" : "Save")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Item Modal */}
            {showItemModal && (
                <div className="modal-overlay" onClick={() => setShowItemModal(false)}>
                    <div className="modal-content modal-lg" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Add Purchase Item</h2>
                            <button onClick={() => setShowItemModal(false)} className="modal-close">×</button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Vendor <span className="required">*</span></label>
                                <div className="search-wrapper">
                                    <input
                                        ref={vendorInputRef}
                                        type="text"
                                        placeholder="Search vendor..."
                                        value={vendorSearch}
                                        onChange={handleVendorSearch}
                                        autoComplete="off"
                                    />
                                    {showVendorDropdown && (
                                        <div className="dropdown" ref={vendorDropdownRef}>
                                            {loadingVendors ? (
                                                <div className="dropdown-loading">Loading vendors...</div>
                                            ) : filteredVendors.length > 0 ? (
                                                filteredVendors.map(v => (
                                                    <div key={v.id} className="dropdown-item" onClick={() => selectVendor(v)}>
                                                        <strong>{v.name}</strong>
                                                        {v.phone && <span className="text-muted"> {v.phone}</span>}
                                                        {v.category && <span className="text-muted"> {v.category}</span>}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="dropdown-empty">No vendors found</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {selectedVendor && (
                                    <div className="selected-info">
                                        Selected: <strong>{selectedVendor.name}</strong>
                                    </div>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Product <span className="required">*</span></label>
                                <div className="search-wrapper">
                                    <input
                                        ref={productInputRef}
                                        type="text"
                                        placeholder="Search product..."
                                        value={productSearch}
                                        onChange={handleProductSearch}
                                        autoComplete="off"
                                    />
                                    {showProductDropdown && (
                                        <div className="dropdown" ref={productDropdownRef}>
                                            {loadingProducts ? (
                                                <div className="dropdown-loading">Loading products...</div>
                                            ) : filteredProducts.length > 0 ? (
                                                filteredProducts.map(p => (
                                                    <div key={p.id} className="dropdown-item" onClick={() => selectProduct(p)}>
                                                        <strong>{p.item_name}</strong>
                                                        <span className="text-muted"> ({p.category})</span>
                                                        {p.base_unit && <span className="text-muted"> - {p.base_unit}</span>}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="dropdown-empty">No products found</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {selectedProduct && (
                                <div className="info-card">
                                    <div className="info-row">
                                        <span className="info-label">Product:</span>
                                        <span className="info-value">{selectedProduct.item_name}</span>
                                    </div>
                                    <div className="info-row">
                                        <span className="info-label">Category:</span>
                                        <span className="info-value">{selectedProduct.category}</span>
                                    </div>
                                    <div className="info-row">
                                        <span className="info-label">Base Unit:</span>
                                        <span className="info-value">{selectedProduct.base_unit || "PCS"}</span>
                                    </div>
                                    {selectedProduct.purchase_packaging && (
                                        <div className="info-row">
                                            <span className="info-label">Packaging:</span>
                                            <span className="info-value">{selectedProduct.packaging_quantity || 1} {selectedProduct.purchase_packaging}</span>
                                        </div>
                                    )}
                                    {selectedProduct.vendor_name && (
                                        <div className="info-row">
                                            <span className="info-label">Default Vendor:</span>
                                            <span className="info-value">{selectedProduct.vendor_name}</span>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Quantity <span className="required">*</span></label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        value={currentItem.quantity}
                                        onChange={e => {
                                            setCurrentItem({
                                                ...currentItem, 
                                                quantity: e.target.value
                                            });
                                        }}
                                        placeholder="Enter quantity (e.g., 10, 5.5)"
                                    />
                                    <small className="hint-text">
                                        Example: 10 pieces, 5 kg, 2.5 liters
                                    </small>
                                </div>
                                <div className="form-group">
                                    <label>Unit</label>
                                    <input
                                        type="text"
                                        value={currentItem.unit}
                                        onChange={e => setCurrentItem({...currentItem, unit: e.target.value})}
                                        placeholder="KG, L, PCS, BAG"
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Total Price (TZS) <span className="required">*</span></label>
                                    <input
                                        type="number"
                                        step="1"
                                        value={currentItem.total_price}
                                        onChange={e => {
                                            setCurrentItem({
                                                ...currentItem, 
                                                total_price: e.target.value
                                            });
                                        }}
                                        placeholder="Enter total amount paid"
                                    />
                                    <small className="hint-text">
                                        Total amount paid for this quantity
                                    </small>
                                </div>
                                <div className="form-group">
                                    <label>Calculated Price per Unit (TZS)</label>
                                    <input
                                        type="text"
                                        value={(() => {
                                            const qty = safeNumber(currentItem.quantity);
                                            const total = safeNumber(currentItem.total_price);
                                            if (qty > 0 && total > 0) {
                                                const pricePerUnit = total / qty;
                                                return `TZS ${formatAmount(pricePerUnit)}`;
                                            }
                                            return "Will be calculated automatically";
                                        })()}
                                        disabled
                                        className="calculated-input"
                                    />
                                    <small className="hint-text rounding-hint">
                                        Total price will be rounded to nearest 10 TZS. Price per unit = Total ÷ Quantity
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => setShowItemModal(false)} className="btn btn-secondary">Cancel</button>
                            <button onClick={addItem} className="btn btn-primary">Add Item</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Report Modal */}
            {showReportModal && (
                <div className="modal-overlay" onClick={() => setShowReportModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Generate Excel Report</h2>
                            <button onClick={() => setShowReportModal(false)} className="modal-close">×</button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Report Period</label>
                                <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
                                    {REPORT_TYPES.map(type => (
                                        <option key={type.value} value={type.value}>{type.label}</option>
                                    ))}
                                </select>
                            </div>

                            {reportType === "day_to_day" && (
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>From Date</label>
                                        <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label>To Date</label>
                                        <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => setShowReportModal(false)} className="btn btn-secondary">Cancel</button>
                            <button onClick={exportExpenses} disabled={isExporting} className="btn btn-primary">
                                {isExporting ? 'Generating...' : 'Generate Report'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}